import { render, staticRenderFns } from "./DisposalEventList.vue?vue&type=template&id=2c75e2fa&scoped=true&"
import script from "./DisposalEventList.vue?vue&type=script&lang=js&"
export * from "./DisposalEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c75e2fa",
  null
  
)

export default component.exports